import PropTypes from 'prop-types';
import { Box, Button, Typography } from '@mui/material';

import { AddQuestionIcon } from 'assets/icons';

const styles = {
  addQuestionButton: ({ breakpoints }) => ({
    paddingBlock: 5,
    paddingInline: 7,
    gap: 4,
    justifyContent: 'flex-start',
    borderRadius: '20px',
    [breakpoints.up('md')]: {
      paddingBlock: 5,
      paddingInline: 7,
    },
  }),
  icon: ({ palette }) => ({
    width: 30,
    height: 30,
    color: palette.common.white,
  }),
};

const AddQuestionButton = ({ isDisabled = false, onClick, label, customStyles = null }) => (
  <Button fullWidth disabled={isDisabled} onClick={onClick} sx={[styles.addQuestionButton, customStyles]}>
    <Box component={AddQuestionIcon} sx={styles.icon} />

    <Typography variant="h2" component="span" color="text.secondary" textAlign="left">
      {label}
    </Typography>
  </Button>
);

AddQuestionButton.propTypes = {
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  customStyles: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({})]),
};
export default AddQuestionButton;
